import instance from '../utils/axios';

class WorkflowPositionService {
    async getWorkflowPostData(pageIndex, keyword) {
        return await instance.post('/crm/crmConfig/getWorkflowPostData', {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'creatorId.base_staff,creatorId.base_staff.avatar,customerId.crm_customer,departmentId.base_department',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc'
        });
    }

}

export default new WorkflowPositionService();